/**
 * 회원정보 모달 컬럼 정의
 */

import { CreateColumn } from '../../Services/agGrid/createColumn';

/**
 * 회원정보 모달용 컬럼 정의
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs = () => {
  return [
    CreateColumn('depNm1', '본부', 'left', 120, false, false, false, 'text', {
      flex: 1,
    }),
    CreateColumn('depNm2', '부서', 'left', 120, false, false, false, 'text', {
      flex: 1,
    }),
    CreateColumn('depNm3', '팀', 'left', 120, false, false, false, 'text', {
      flex: 1,
    }),
    CreateColumn('depNm4', '파트', 'left', 120, false, false, false, 'text', {
      flex: 1,
    }),
    CreateColumn('position', '직책', 'left', 120, false, false, false, 'text', {
      flex: 1,
    }),
    CreateColumn('name', '성명', 'left', 120, false, false, false, 'text', {
      flex: 1,
    }),
    CreateColumn('id', '아이디', 'left', 120, false, false, true, 'text', {
      flex: 1,
    }),
  ];
};

/**
 * 재해현황 등에서 사용: HEA_BASIC_01과 동일하게 부서1~부서4, 직책, 전화번호, 성명 노출
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefsForAccidentStatus = () => {
  return [
    CreateColumn('depNm1', '본부', 'left', 120, false, false, false, 'text', {
      flex: 1,
    }),
    CreateColumn('depNm2', '부서', 'left', 120, false, false, false, 'text', {
      flex: 1,
    }),
    CreateColumn('depNm3', '팀', 'left', 120, false, false, false, 'text', {
      flex: 1,
    }),
    CreateColumn('depNm4', '파트', 'left', 120, false, false, false, 'text', {
      flex: 1,
    }),
    CreateColumn('rank', '직급', 'left', 120, false, false, false, 'text', {
      flex: 1,
    }),
    CreateColumn('name', '성명', 'left', 120, false, false, false, 'text', {
      flex: 1,
    }),
    CreateColumn('tel', '전화번호', 'left', 140, false, false, false, 'text', {
      flex: 1,
    }),
    CreateColumn('id', '아이디', 'left', 120, false, false, true, 'text', {
      flex: 1,
    }),
  ];
};
